import { ComponentProps } from '@episerver/spa-core/EpiComponent';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import AbroadPackConditionsData from '../../../Models/Content/AbroadPackConditionsBlockData';
import React from 'react';
import { Col, Row, Container } from 'reactstrap';

const AbroadPackConditions = (props) => {


  const test = () => {

    let arr = props.data.rows?.expandedValue;
    let dd = arr;

  }

  return (
    <div className="abroad-pack-conditions">


      <Container>

        <div className="gray-line"></div><br />
        <h1> {props.data.title.value}</h1>
        <ol style={props.data.rows.expandedValue.length == '1' ? { listStyleType: 'none' } : null}>
          {props.data.rows?.expandedValue?.map((item, i) => (
            <Row key={i} >
              <Col xs="12" sm="12" md="12" >
                <li>{item.text.value}</li>
              </Col>
            </Row>
          ))}
        </ol>
      </Container>


    </div>
  );
};

export default AbroadPackConditions;
